import {Map} from 'immutable';

import {ADMIN_BALANCE_NOTIFICATIONS, ADMIN_BALANCE_USAGE, ADMIN_BALANCE_USAGE_ALL} from '../lib/constant';

const initialState = Map({notificationsResponse: {}, usageResponse: {}, usageAllResponse: {}})

export default function(state = initialState, action) {
  switch (action.type) {
  case ADMIN_BALANCE_NOTIFICATIONS:
    return {...state, notificationsResponse: action.payload};
  case ADMIN_BALANCE_USAGE_ALL:
    return {...state, usageAllResponse: action.payload};
  case ADMIN_BALANCE_USAGE:
    return {...state, usageResponse: action.payload};
  default:
    return state;
  }
}
